import IdentitiesApi from 'api/v2/admins/identities-api'
import React,{ useState, useEffect } from 'react'
import { Card, CardHeader, Button, Table,Alert } from 'reactstrap'
import PropTypes from 'prop-types'
import PriceUtil from 'utils/price-util'

const propTypes = {
  selectedSeller: PropTypes.object
}

const defaultProps = {
  accounts: []
}

const AccountLinkSellerDetailView = ({ selectedSeller }) => {
  const [ seller, setSeller ] = useState(undefined)

  useEffect(() => {
    if (selectedSeller.email) {
      IdentitiesApi.getSellerProfile(selectedSeller.email)
        .then((response) => {
          setSeller(response.data.seller)
        })
        .catch((error) => {
          console.log(error)
        })
    }

  }, [ selectedSeller.email ])

  return (
    <>
      {
        seller && (
          <Card>
            <CardHeader>
              <div>
                <span className='small text-uppercase text-light font-weight-bolder'>
                  { selectedSeller?.type }
                </span>
                <h2>
                  <span className='mr-3'>
                    { seller?.name }
                  </span>
                </h2>
                { /* NOTE: will create a component to display customer detail  */ }
                <a
                  href={ `/app/sellers/edit/${seller.id}` }
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button
                    size="sm"
                    type='button'
                    color="primary"
                  >
                    Click to see Seller Detail
                  </Button>
                </a>

                <h2 className='mt-3'>Seller Latest Product</h2>

                {
                  seller.last_products.length > 0 &&
                  (
                    <Table>
                      <thead>
                        <tr>
                          <th>SKU</th>
                          <th>Image</th>
                          <th>Price</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        { seller.last_products.map((product) => (
                          <tr key={ `seller-product-${product.sku}` }>
                            <th scope="row">{ product.sku }</th>
                            <th>
                              <img
                                style={{ width: '5rem' }}
                                src={ product.main_image }
                                alt={ product.sku }
                              />
                            </th>
                            <th>{ PriceUtil.formatToIDR(product.price) }</th>
                            <td>
                              <a
                                href={ `/app/products/${product.id}` }
                                target="_blank"
                                rel="noreferrer"
                              >
                                <Button
                                  size="sm"
                                  type='button'
                                  color="primary"
                                >
                                  Detail
                                </Button>
                              </a>
                            </td>
                          </tr>
                        )) }
                      </tbody>
                    </Table>
                  )
                }
                <Alert
                  className={ seller.last_products.length > 0 ? 'd-none' : 'd-block' }
                  color='info'
                >
                  <i className='fas fa-info-circle mr-3' />
                  <span>
                    { 'Seller has no products' }
                  </span>
                </Alert>

              </div>
            </CardHeader>
          </Card>
        )
      }
    </>
  )
}

AccountLinkSellerDetailView.propTypes    = propTypes
AccountLinkSellerDetailView.defaultProps = defaultProps


export default AccountLinkSellerDetailView